import React, {FC, ReactNode} from 'react';
import {View} from 'react-native';

import Space from '@/components/Space/Space';
import Text from '@/components/Text';
import TouchableCard from '@/components/Touchable/TouchableCard';
import spacing from '@/constants/spacing';
import {ThemeContext} from '@/theme';
import {ITheme} from '@/types/theme';

interface IProps {
  onPress: () => void;
  name: string;
  theme: ITheme;
  suffixComponent?: ReactNode;
  disabled?: boolean;
}

const CARD_HEIGHT = 60;

const ThemeCard: FC<IProps> = ({
  onPress,
  theme,
  name,
  suffixComponent,
  disabled = false,
}) => {
  return (
    <ThemeContext.Provider value={{theme}}>
      <TouchableCard
        onPress={onPress}
        disabled={disabled}
        style={{
          height: CARD_HEIGHT,
          justifyContent: 'center',
        }}>
        {({actionColor}) => (
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              paddingHorizontal: spacing.xxs,
            }}>
            <Text
              style={{flexGrow: 0}}
              align="center"
              size="m"
              weight="semibold"
              numberOfLines={1}
              color={actionColor()}>
              {name}
            </Text>
            {suffixComponent && <Space ml="xs">{suffixComponent}</Space>}
          </View>
        )}
      </TouchableCard>
    </ThemeContext.Provider>
  );
};

export default ThemeCard;
